import React from "react";
import PropTypes from "prop-types";
import ElementFactory from "../element-factory";

const SceneLayer = ({ scene, index, activeBreakpoint, animationKey, activeSceneIndex }) => {
  const activeAnimation = scene.animateEffect || scene.animation;
  
  // Extrae el nivel de zIndex del primer componente de la escena para setearlo en el contenedor padre
  const firstElementKey = Object.keys(scene.elements || {});
  const sceneZIndex = scene.elements?.[firstElementKey]?.positions?.[activeBreakpoint]?.zIndex ?? index;

  // Renderizador iterativo que delega el pintado a la fábrica atómica
  const renderElements = () => {
    if (!scene.elements) return null;
    return Object.entries(scene.elements).map(([key, element]) => (
      <ElementFactory
        key={key}
        elementKey={key}
        element={element}
        activeBreakpoint={activeBreakpoint}
        // ✨ SOLUCIÓN: Verifica si esta capa de escena exacta es la seleccionada para edición
        isEditingCurrentScene={activeSceneIndex !== null && activeSceneIndex === index}
      />
    ));
  };

  if (activeAnimation) {
    return (
      <div
        className="banner-scene-layer"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "box-none",
          zIndex: sceneZIndex,
          "--scene-animation": activeAnimation,
        }}
      >
        {renderElements()}
      </div>
    );
  }

  // Capa base estática (como la escena del estadio de fondo)
  return (
    <div 
      className="banner-scene-layer non-animated"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "box-none",
        zIndex: sceneZIndex,
      }}
    >
      {renderElements()}
    </div>
  );
};

SceneLayer.propTypes = {
  scene: PropTypes.shape({
    animateEffect: PropTypes.string,
    animation: PropTypes.string,
    elements: PropTypes.object,
  }).isRequired,
  index: PropTypes.number.isRequired,
  activeBreakpoint: PropTypes.string.isRequired,
  animationKey: PropTypes.number.isRequired,
  // Validador del índice del Playground para el control de puntero del ratón
  activeSceneIndex: PropTypes.number,
};

export default SceneLayer;
